import { useEffect, useState } from "react";
import { HdgTextInput } from "../../../components/hdg-text-input";
import { Button, Chip, Stack, Typography } from "@mui/material";
import { useDesignerApplicationContext } from "../../../hooks/designer-application-context";
import AddIcon from "@mui/icons-material/Add";

export const EducationForm = ({
  isEditable = true,
}: {
  isEditable?: boolean;
}) => {
  // Grab the typed updater; read `application` via a safe cast (context doesn't type it)
  const ctx = useDesignerApplicationContext();
  const { updateApplicationData, saveApplicationDataImmediately } = ctx;
  const application = (ctx as any).application ?? {};

  const [textState, setTextState] = useState<string>("");
  const [credentials, setCredentials] = useState<string[]>(
    (application?.education ?? []) as string[]
  );

  // Ensure we always work with a string[]
  const value = (application?.education ?? []) as string[];

  // Sync local state if application data is refreshed from server
  useEffect(() => {
    setCredentials(value);
  }, [application?.education]);

  const setEducation = async (next: string[]) => {
    try {
      await saveApplicationDataImmediately({ education: next });
    } catch (error) {
      // Fallback to regular update if immediate save fails
      updateApplicationData({
        education: next,
      });
    } finally {
      setCredentials(next);
    }
  };

  if (!isEditable) {
    return (
      <>
        {credentials.map((item) => (
          <Chip key={item} label={item} style={{ margin: "5px", borderRadius: "50px", padding: "8px" }} />
        ))}
      </>
    );
  }

  const handleSubmit = (raw?: string) => {
    const candidate = typeof raw === "string" ? raw : textState;
    const trimmed = candidate.trim();
    if (!trimmed) return;

    const exists = credentials.some(
      (v) => v.trim().toLowerCase() === trimmed.toLowerCase()
    );
    if (!exists) {
      const next = [...credentials, trimmed];
      setCredentials(next);
      setEducation(next);
      setTextState("");
    }
  };

  const handleRemove = (index: number) => {
    const next = [...credentials];
    next.splice(index, 1);
    setCredentials(next);
    setEducation(next);
  };

  return (
    <div>
      <Stack direction={"row"} spacing={1} style={{ marginBottom: "10px" }}>
        {credentials.map((item, index) => (
          <Chip key={`${item}-${index}`} label={item} onDelete={() => handleRemove(index)} sx={{ 
            py: 0.5, // 8px
            px: 0.5, // 8px
            minWidth: 'auto',
            width: 'fit-content',
            borderRadius: 50 
          }} />
        ))}
      </Stack>

      <HdgTextInput
        label={"Credentials & Recognition"}
        onChange={(val) => setTextState(String(val))}
        onSubmit={(val) => handleSubmit(String(val))}
        value={textState}
        type="text"
        name="education"
        multiline
        endDecorator={
          <Button
            variant="contained"
            disabled={
              !textState.trim() ||
              credentials.some((v) => v.trim().toLowerCase() === textState.trim().toLowerCase())
            }
            startIcon={<AddIcon />}
            onClick={() => handleSubmit()}
            sx={{ mb: 2 }}
          >
            <Typography variant="body1" component="span">
              Add
            </Typography>
          </Button>
        }
      />
    </div>
  );
};
